<script>
import i18n from "@/plugins/i18n";
import { mapActions } from 'vuex';
import Axios from 'axios';
import NotificationCount from '../../../components/NotificationCount.vue';

export default {
    components: {
        NotificationCount
    },

    data() {
        return {
            notificationsOpen: false,
            linkNotificationsOpen: false,
            systemNotificationsOpen: false,
            otherNotificationsOpen: false,

            linkNotifications: [],
            systemNotifications: [],
            otherNotifications: [],

            showUnread: true
        }
    },

    computed: {
        notificationTypes() {
            const types = [
                { val: "link", text: i18n.t('auditor.notification_btn.requests'), icon: "fi fi-ss-city" },
                { val: "system", text: i18n.t('notifications.system'), icon: "fi fi-ss-wind-turbine" },
                { val: "other", text: i18n.t('notifications.other'), icon: "fi fi-ss-bell" },
            ];
            return types;
        },

        isNotificationsButtonsActive() {
            const active = (this.linkNotificationsOpen || this.systemNotificationsOpen || this.otherNotificationsOpen);
            return active;
        },

        linkNotificationsCount() {
            return this.linkNotifications.length;
        },

        totalNotificationsCount() {
            return this.linkNotificationsCount;
        }
    },

    async mounted() {
        await this.initialize();
    },

    methods: {

        ...mapActions("auditor", [
            'getAuditorRelationRequestsByAuditor',
            'changeAuditorCompany',
            'deleteAuditorRelationRequest',
        ]),

        // initial //

        async initialize() {
            await this.setHeadersHelper();
            await this._getAuditorRelationRequestsByAuditor();
            //await this.updateNotifications();
        },

        async updateNotifications() {
            setTimeout(async () => {
               await this._getAuditorRelationRequestsByAuditor();
               //await this.updateNotifications();
            }, 15000);
        },

        // api calls //

        async _getAuditorRelationRequestsByAuditor() {
            this.linkNotifications = [];

            await this.getAuditorRelationRequestsByAuditor()
                .then( (res) => {
                    this.linkNotifications = res.data;
                })
                .catch(({ response }) => {
                    console.error(this.$parseResMessage(response.messageName));
                })
        },

        async _changeAuditorCompany(c) {
            console.log(c);
            const params = {
                auditor_company_id: c.auditor_company_id,
                audited_company_id: c.audited_company_id,
            }

            this.changeAuditorCompany(params)
                .then(response => {
                    this._getAuditorRelationRequestsByAuditor();
                    this.$notify('success', response.data.messageName);
                    setTimeout(() => {
                        window.location.reload(); // TODO: "maybe use a state manipulator
                    }, 300);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        async _deleteAuditorRelationRequest(c) {
            const params = {
                auditor_relation_request_id: c.auditor_relation_request_id,
            }

            this.deleteAuditorRelationRequest(params)
                .then(response => {
                    this._getAuditorRelationRequestsByAuditor();
                    this.$notify('success', response.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },
        
        // handlers //

        async handleClickNotifications(bool) {
            if (bool == true) {
                await this._getAuditorRelationRequestsByAuditor();
            }

            await this.setNotificationsOpen(bool);
        },

        async handleClickNotificationButton(item) {
            if (!item) {
                await this.resetNotificationButtons();
                await this.setNotificationsOpen(true);
                await this.setShowUnread(true);
            } else if (item.val === "link") {
                await this.setNotificationsOpen(false);
                await this.setSystemNotificationsOpen(false);
                await this.setOtherNotificationsOpen(false);
                await this.setLinkNotificationsOpen(true);
            } else if (item.val === "system") {
                await this.setNotificationsOpen(false);
                await this.setSystemNotificationsOpen(true);
                await this.setOtherNotificationsOpen(false);
                await this.setLinkNotificationsOpen(false);
            } else if (item.val === "other") {
                await this.setNotificationsOpen(false);
                await this.setSystemNotificationsOpen(false);
                await this.setOtherNotificationsOpen(true);
                await this.setLinkNotificationsOpen(false);
            } else {
                console.error("Invalid item on handleClickNotificationButton: ", item);
            }
        },

        async handleClickShowUnread(bool) {
            await this.setShowUnread(bool);
        },

        // setters //

        async setNotificationsOpen(bool) {
            this.notificationsOpen = bool;
        },

        async setLinkNotificationsOpen(bool) {
            this.linkNotificationsOpen = bool;
        },

        async setSystemNotificationsOpen(bool) {
            this.systemNotificationsOpen = bool;
        },

        async setOtherNotificationsOpen(bool) {
            this.otherNotificationsOpen = bool;
        },

        async setShowUnread(bool) {
            this.showUnread = bool;
        },

        async resetNotificationButtons() {
            await this.setSystemNotificationsOpen(false);
            await this.setOtherNotificationsOpen(false);
            await this.setLinkNotificationsOpen(false);
        },

        async resetEverything() {
            await this.setSystemNotificationsOpen(false);
            await this.setOtherNotificationsOpen(false);
            await this.setLinkNotificationsOpen(false);
            await this.setNotificationsOpen(false);
            await this.setShowUnread(true);
        },

        // emitter //

        handleComponentClick(e) {
            this.$emit("click", e);
        },

        // utils //

        async setHeadersHelper() {
            Axios.defaults.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
        },

        getNotificationsCount(item) {
            if (item.val === "link") {
                return this.linkNotificationsCount;
            } else {
                return 0; // return 0 for now
            }
        },
        
        dateFormat(value) {
            if (!value) return "N/A";
            let current_datetime = new Date(value);
            return (
                current_datetime.getDate() +
                "/" +
                (current_datetime.getMonth() + 1) +
                "/" +
                current_datetime.getFullYear() +
                " - " +
                current_datetime.getHours() +
                ":" +
                (current_datetime.getMinutes() < 10 ? "0" : "") +
                current_datetime.getMinutes()
            );
        }
    }
}
</script>

<template>
    <div class="notifications-button-container" tabindex="0" @click="handleComponentClick()" @blur="resetEverything()" @keydown.esc="resetEverything()">

        <notification-count v-if="totalNotificationsCount > 0" :count="totalNotificationsCount" class="notifications-count"/>
      
        <i v-if="!notificationsOpen && !isNotificationsButtonsActive" class="notifications-button fa-solid fa-envelope" @click="handleClickNotifications(true)"></i>
        <i v-else class="notifications-button fa-solid fa-envelope-open" @click="resetEverything()"></i>

        <Transition name="fade">
            <div class="notification-buttons-container" v-if="notificationsOpen">
                <div v-for="item in notificationTypes" :key="item.val" class="notification-type-button"
                    @click="handleClickNotificationButton(item)"
                >
                    <notification-count v-if="getNotificationsCount(item) > 0" :count="getNotificationsCount(item)" class="notifications-count"/>
                    <div class="button-inner">
                        <i :class="item.icon"></i>
                        <span>{{ item.text }}</span>
                    </div>
                </div>
            </div>
        </Transition>
        
        <Transition name="fade">
            <div class="notifications-container" v-if="linkNotificationsOpen">
                <div class="back-btn-container">
                    <i @click="handleClickNotificationButton()" class="fa-solid fa-circle-arrow-left"></i>
                </div>
                <div v-for="item in linkNotifications" :key="item.val" class="notification" :style="{'pointer-events': !showUnread ? 'none' : null}">
                    <div class="notification-text">
                        {{ item.company_name }}{{ $t('auditor.notification_btn.request_msg') }}
                    </div>
                    <div class="notification-interact-btns-ctr" v-if="showUnread">
                        <i @click="_changeAuditorCompany(item)" v-b-tooltip.hover="{title: $t('notifications.accept_invitation')}" class="accept-btn fa-solid fa-circle-check"></i>
                        <i @click="_deleteAuditorRelationRequest(item)" v-b-tooltip.hover="{title: $t('notifications.delete')}" class="delete-btn fa-solid fa-circle-xmark"></i>
                    </div>
                </div>
                <div class="no-notifications-text" v-if="linkNotifications.length == 0">
                    {{ $t('notifications.nothing')}}
                </div>
            </div>
        </Transition>
        
        <Transition name="fade">
            <div class="notifications-container" v-if="systemNotificationsOpen">
                <div class="show-unread-ctr">
                    <div class="show-unread-only-btn" :class="{'selected-btn': showUnread}" @click="handleClickShowUnread(true)">
                        Unread
                    </div>
                    <div class="show-all-btn" :class="{'selected-btn': !showUnread}" @click="handleClickShowUnread(false)">
                        All
                    </div>
                </div>
                <div class="back-btn-container">
                    <i @click="handleClickNotificationButton()" class="fa-solid fa-circle-arrow-left"></i>
                </div>
                <div v-for="item in systemNotifications" :key="item.val" class="notification">
                    <div class="notification-text" v-html="item.msg">

                    </div>
                    <div class="notification-interact-btns-ctr">
                        <i class="fa-solid fa-ban"></i>
                        <i class="fa-solid fa-circle-xmark"></i>
                        <i class="fa-solid fa-circle-check"></i>
                    </div>
                </div>
                <div class="no-notifications-text" v-if="systemNotifications.length == 0">
                    {{ $t('notifications.nothing')}}
                </div>
            </div>
        </Transition>
        
        <Transition name="fade">
            <div class="notifications-container" v-if="otherNotificationsOpen">
                <div class="show-unread-ctr">
                    <div class="show-unread-only-btn" :class="{'selected-btn': showUnread}" @click="handleClickShowUnread(true)">
                        Unread
                    </div>
                    <div class="show-all-btn" :class="{'selected-btn': !showUnread}" @click="handleClickShowUnread(false)">
                        All
                    </div>
                </div>
                <div class="back-btn-container">
                    <i @click="handleClickNotificationButton()" class="fa-solid fa-circle-arrow-left"></i>
                </div>
                <div v-for="item in otherNotifications" :key="item.val" class="notification">
                    <div class="notification-text" v-html="item.msg">

                    </div>
                    <div class="notification-interact-btns-ctr">
                        <i class="fa-solid fa-ban"></i>
                        <i class="fa-solid fa-circle-xmark"></i>
                        <i class="fa-solid fa-circle-check"></i>
                    </div>
                </div>
                <div class="no-notifications-text" v-if="otherNotifications.length == 0">
                    {{ $t('notifications.nothing')}}
                </div>
            </div>
        </Transition>

    </div>
</template>

<style lang='scss' scoped>
    .fade-active {
        transition: opacity .66s ease;
    }

    .fade-from,
    .fade-to {
        opacity: 1;
    }
    
    .notifications-button-container {
        margin-right: 1em;
        z-index: 999;
        position: relative;

        > .notifications-count {
            position: absolute;
            top: 0;
            right: 0;
            transform: translateX(50%);
        }
    }

    .notifications-button {
        padding-top: .15em;
        font-size: 2em;
        color: var(--sustainfinity-navy--hover);
            
        transition: all 150ms;
        cursor: pointer;
        &:hover {
            color: var(--sustainfinity-navy);
        }
    }

    .notification-buttons-container {
        position: absolute;
        transform: translateY(105%);
        bottom: 0px;
        right: 0;

        background-color: whitesmoke;
        border-radius: 1em;
        border: thin solid var(--sustainfinity-navy);

        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: center;
        flex-wrap: wrap;

        padding: .5em;
        width: 200px;

        > .notification-type-button {
            width: 50%;
            min-height: 70px;
            max-height: 70px;
            border-radius: 7px;

            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            align-items: center;

            cursor: pointer;
            &:hover {
                background-color: lightgray;
            }

            position: relative;
            > .notifications-count {
                position: absolute;
                top: 0;
                right: 0;
            }

            > .button-inner {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-content: center;
                align-items: center;
                text-align: center;
                color: black;

                > span {
                    font-weight: bold;
                    font-style: italic;
                    font-size: .9em;
                }
            }
        }
    }

    .notifications-container {
        position: absolute;
        transform: translateY(105%);
        bottom: 0px;
        right: 0;

        background-color: whitesmoke;
        border-radius: .5em;
        border: thin solid var(--sustainfinity-navy);

        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-content: flex-start;
        align-items: flex-start;

        width: 400px;

        > .notification {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            align-items: center;

            padding: .5em;
            width: 100%;
            border-bottom: thin solid lightgray;
            color: black;

            transition: all 150ms;
            cursor: pointer;
            &:hover {
                background-color: lightgray;
            }

            > .notification-text {
                flex: .65;
            }

            > .marked-read-message {
                flex: 1 !important;
                pointer-events: none !important;
                cursor: default !important;
            }

            > .notification-interact-btns-ctr {
                flex: .35;
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                align-content: center;
                align-items: center;
                border-left: thin solid gray;

                > i {
                    color: black;
                    transition: all 100ms;
                }

                > .accept-btn:hover {
                    color: var(--sustainfinity-green);
                }

                > .delete-btn:hover {
                    color: var(--invalid-input);
                }

                > .block-btn:hover {
                    color: rgb(140, 0, 0);
                }
            }
        }

        > .show-unread-ctr {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            align-items: center;
            width: 100%;
            border-bottom: thin solid lightgray;

            > div {
                text-align: center;
                flex: .5;
                transition: all 150ms;
                cursor: pointer;
                &:hover {
                    background-color: lightgray;
                }
            }

            > .show-unread-only-btn {
                border-right: thin solid lightgray;
            }

            > .selected-btn {
                background-color: gray;
                color: white;
            }
        }

        > .no-notifications-text {
            padding: 1em;
        }
    }

    .back-btn-container {
        padding: .5em;
        width: 100%;
        border-bottom: thin solid lightgray;
        > i {
            color: var(--sustainfinity-navy);
            transition: all 150ms;
            cursor: pointer;
            &:hover {
                color: var(--sustainfinity-navy--hover);
            }
        }
    }

</style>